import { ItemCategory } from "src/api-service";

// **************************************************************************
// CATEGORY STATE
// **************************************************************************
export interface CategoryState {
    category: ItemCategory | null;
    categories: ItemCategory[];
    categoriesLoading: boolean;
}

export const initialCategoryState: CategoryState = {
    category: null,
    categories: [],
    categoriesLoading: false,
};
